<mat-chip-listbox [value]="activeLang()" (change)="onLangChange($event)">
  @for (lang of langs; track lang) {
    <mat-chip-option [value]="lang">{{ lang.toUpperCase() }}</mat-chip-option>
  }
</mat-chip-listbox>
<div class="mt-3 flex flex-col gap-2">
  @for (item of activeItems(); track $index) {
    <div class="flex gap-2 items-center">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <input matInput [value]="item" (input)="updateItem($index, $any($event.target).value)" />
      </mat-form-field>
      <button
        mat-icon-button
        type="button"
        color="warn"
        [aria-label]="'generic.remove-item' | translate"
        [matTooltip]="'generic.remove-item' | translate"
        (click)="removeItem($index)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }
  <button mat-stroked-button type="button" class="self-start" (click)="addItem()">
    <mat-icon>add</mat-icon>
    {{ 'generic.add-item' | translate }}
  </button>
</div>
